<div class="gap-x-md items-center p-md hidden md:flex">
  <core-icon-button (triggered)="sidebar.toggle()" btnStyle="secondary" icon="dock_to_right" />
  <core-svs-logo class="h-[40px]" />
</div>
